import React from "react";
import HeroSection from "./hero";
import CONTACT_US from "./footer";
import Service from "./service";
import About from "./about";
import CountU from "./count";
import DemoCarousel from "./slick";
import ScrollArrow from "./ScrollUp";
import Testimonials from "./testimonial";
import Map from './map';
function App() {
  return (
    <>
      <HeroSection />
      <Service />
      <CountU />
      <DemoCarousel />
      <Testimonials />
      <About />
      <Map/>
      <CONTACT_US />
      <ScrollArrow />
    </>
  );
}
export default App;
